import React from "react";
import { DateTime } from "luxon";
import { useTheme } from "react-jss";
import useStyles from "./MobilePreview.styles";

export function MobilePreview({ render }) {
    const desktopRef: React.Ref<HTMLDivElement> = React.useRef();
    const mobileRef: React.Ref<HTMLDivElement> = React.useRef();

    const theme = useTheme();
    const classes = useStyles({ theme });

    let ignoreNextEvent = false;
    const onScroll = React.useCallback(
        (event) => {
            if (ignoreNextEvent) {
                ignoreNextEvent = false;
                return;
            }
            const desktop = desktopRef.current;
            const mobile = mobileRef.current;
            const el = event.target;
            const scrollsv = el.scrollTop / (el.scrollHeight - el.clientHeight);
            const sibling = el === mobile ? desktop : mobile;
            ignoreNextEvent = true;
            sibling.scrollTop = scrollsv * (sibling.scrollHeight - sibling.clientHeight);
        },
        [desktopRef.current, mobileRef.current],
    );

    React.useEffect(() => {
        const desktop = desktopRef.current;
        const mobile = mobileRef.current;
        desktop.addEventListener("scroll", onScroll);
        mobile.addEventListener("scroll", onScroll);
        return function cleanup() {
            desktop.removeEventListener("scroll", onScroll);
            mobile.removeEventListener("scroll", onScroll);
        };
    }, [onScroll]);

    return (
        <div className={classes.preview}>
            <div className={classes.previewDesktop} ref={desktopRef}>
                {render()}
            </div>
            <div className={classes.previewMobile}>
                <div className={classes.deviceFrame}>
                    <div className={classes.deviceFrameTime}>{DateTime.now().toFormat("h:mm")}</div>
                    <div className={classes.deviceFrameImage} />
                    <div className={classes.deviceFrameContent} ref={mobileRef}>
                        {render()}
                    </div>
                </div>
            </div>
        </div>
    );
}
